import { createTheme } from '@mui/system';
import ThemeConstants from './ThemeConstants';

const { palette } = createTheme();
const { augmentColor } = palette;
export const createColor = (mainColor: string) =>
  augmentColor({ color: { main: mainColor } });

export default {
  primary: {
    main: ThemeConstants.primary.main,
    light: ThemeConstants.primary.light,
    inputLabel: ThemeConstants.primary.inputLabel,
  },

  secondary: {
    main: ThemeConstants.secondary.main,
  },

  common: {
    main: ThemeConstants.common.lightBackgroundColor,
    lightBackgroundColor: ThemeConstants.common.lightBackgroundColor,
    grey150: ThemeConstants.common.grey150,
    grey350: ThemeConstants.common.grey350,
    grey850: ThemeConstants.common.grey850,
    blue400: ThemeConstants.common.blue400,
    blue600: ThemeConstants.common.blue600,
    lightGreen: ThemeConstants.common.lightGreen,
    border: ThemeConstants.common.border,
    counterRed: ThemeConstants.common.counterRed,
    error: ThemeConstants.common.error,
    secondaryButtonHover: ThemeConstants.common.secondaryButtonHover,
    borderInput: ThemeConstants.common.borderInput,
    hover: ThemeConstants.common.hover,
    green300: ThemeConstants.common.green300,
    green600: ThemeConstants.common.green600,
    otpInput: ThemeConstants.common.otpInput,
    gray: ThemeConstants.common.gray,
    hoverGray: ThemeConstants.common.hoverGray,
    freeGray: ThemeConstants.common.freeGray,
    newBlue: ThemeConstants.common.newBlue,
    iconBackground: ThemeConstants.common.iconBackground,
    yellow700: ThemeConstants.common.yellow700,
    warningNote: ThemeConstants.common.warningNote,
  },

  footer: {
    backgroundColor: ThemeConstants.footer.backgroundColor,
    verticalLine: ThemeConstants.footer.verticalLine,
  },

  grey: {
    400: ThemeConstants.grey[400],
    500: ThemeConstants.grey[500],
    600: ThemeConstants.grey[600],
    800: ThemeConstants.grey[800],
  },

  eventChip: {
    posted: ThemeConstants.eventChip.posted,
    postedText: ThemeConstants.eventChip.postedText,
    requestedText: ThemeConstants.eventChip.requestedText,
    requested: ThemeConstants.eventChip.requested,
    bookedText: ThemeConstants.eventChip.bookedText,
    booked: ThemeConstants.eventChip.booked,
    workshiftText: ThemeConstants.eventChip.workshiftText,
  },

  pharmacist: {
    requested: ThemeConstants.pharmacists.requested,
    requestedLight: ThemeConstants.pharmacists.requestedLight,

    booked: ThemeConstants.pharmacists.booked,
    bookedLight: ThemeConstants.pharmacists.bookedLight,

    availability: ThemeConstants.pharmacists.availability,
    availabilityLight: ThemeConstants.pharmacists.availabilityLight,

    tempAvailability: ThemeConstants.pharmacists.tempAvailability,
    tempAvailabilityLight: ThemeConstants.pharmacists.tempAvailabilityLight,

    posted: ThemeConstants.pharmacists.posted,

    workshift: ThemeConstants.pharmacists.workshift,
    workshiftLight: ThemeConstants.pharmacists.workshiftLight,

    vacation: ThemeConstants.pharmacists.vacation,
    vacationLight: ThemeConstants.pharmacists.vacationLight,

    newVacation: ThemeConstants.pharmacists.newVacation,
    newVacationLight: ThemeConstants.pharmacists.newVacationLight,
  },

  technician: {
    requested: ThemeConstants.technician.requested,
    requestedLight: ThemeConstants.technician.requestedLight,

    booked: ThemeConstants.technician.booked,
    bookedLight: ThemeConstants.technician.bookedLight,

    availability: ThemeConstants.technician.availability,
    availabilityLight: ThemeConstants.technician.availabilityLight,

    tempAvailability: ThemeConstants.technician.tempAvailability,
    tempAvailabilityLight: ThemeConstants.technician.tempAvailabilityLight,

    workshift: ThemeConstants.technician.workshift,
    workshiftLight: ThemeConstants.technician.workshiftLight,

    vacation: ThemeConstants.technician.vacation,
    vacationLight: ThemeConstants.technician.vacationLight,

    newVacation: ThemeConstants.technician.newVacation,
    newVacationLight: ThemeConstants.technician.newVacationLight,
  },

  student: {
    requested: ThemeConstants.student.requested,
    requestedLight: ThemeConstants.student.requestedLight,

    booked: ThemeConstants.student.booked,
    bookedLight: ThemeConstants.student.bookedLight,

    availability: ThemeConstants.student.availability,
    availabilityLight: ThemeConstants.student.availabilityLight,

    tempAvailability: ThemeConstants.student.tempAvailability,
    tempAvailabilityLight: ThemeConstants.student.tempAvailabilityLight,

    workshift: ThemeConstants.student.workshift,
    workshiftLight: ThemeConstants.student.workshiftLight,

    vacation: ThemeConstants.student.vacation,
    vacationLight: ThemeConstants.student.vacationLight,

    newVacation: ThemeConstants.student.newVacation,
    newVacationLight: ThemeConstants.student.newVacationLight,
  },

  pharmacy: {
    posted: ThemeConstants.pharmacy.posted,
    postedLight: ThemeConstants.pharmacy.postedLight,

    booked: ThemeConstants.pharmacy.booked,
    bookedLight: ThemeConstants.pharmacy.bookedLight,

    tempAvailability: ThemeConstants.pharmacists.tempAvailability,
    tempAvailabilityLight: ThemeConstants.pharmacists.tempAvailabilityLight,

    requested: ThemeConstants.pharmacy.requested,
    requestedLight: ThemeConstants.pharmacy.requestedLight,

    pending: ThemeConstants.pharmacy.pending,
    pendingLight: ThemeConstants.pharmacy.pendingLight,
  },

  admin: {
    posted: ThemeConstants.pharmacy.posted,
    postedLight: ThemeConstants.pharmacy.postedLight,

    booked: ThemeConstants.pharmacy.booked,
    bookedLight: ThemeConstants.pharmacy.bookedLight,

    availability: ThemeConstants.pharmacists.availability,
    availabilityLight: ThemeConstants.pharmacists.availabilityLight,

    tempAvailability: ThemeConstants.pharmacists.tempAvailability,
    tempAvailabilityLight: ThemeConstants.pharmacists.tempAvailabilityLight,

    requested: ThemeConstants.pharmacy.requested,
    requestedLight: ThemeConstants.pharmacy.requestedLight,

    total: ThemeConstants.pharmacists.availability,
    totalLight: ThemeConstants.pharmacists.availabilityLight,

    workshift: ThemeConstants.pharmacists.workshift,
    workshiftLight: ThemeConstants.pharmacists.workshiftLight,

    vacation: ThemeConstants.pharmacists.vacation,
    vacationLight: ThemeConstants.pharmacists.vacationLight,

    newVacation: ThemeConstants.pharmacists.newVacation,
    newVacationLight: ThemeConstants.pharmacists.newVacationLight,
  },

  superadmin: {
    posted: ThemeConstants.pharmacy.posted,
    postedLight: ThemeConstants.pharmacy.postedLight,

    booked: ThemeConstants.pharmacy.booked,
    bookedLight: ThemeConstants.pharmacy.bookedLight,

    tempAvailability: ThemeConstants.pharmacists.tempAvailability,
    tempAvailabilityLight: ThemeConstants.pharmacists.tempAvailabilityLight,

    availability: ThemeConstants.pharmacists.availability,
    availabilityLight: ThemeConstants.pharmacists.availabilityLight,

    requested: ThemeConstants.pharmacy.requested,
    requestedLight: ThemeConstants.pharmacy.requestedLight,

    total: ThemeConstants.pharmacists.availability,
    totalLight: ThemeConstants.pharmacists.availabilityLight,

    workshift: ThemeConstants.pharmacists.workshift,
    workshiftLight: ThemeConstants.pharmacists.workshiftLight,

    vacation: ThemeConstants.pharmacists.vacation,
    vacationLight: ThemeConstants.pharmacists.vacationLight,

    newVacation: ThemeConstants.pharmacists.newVacation,
    newVacationLight: ThemeConstants.pharmacists.newVacationLight,
  },

  calendarHover: {
    requested: ThemeConstants.calendarHover.requested,
    requestedBorder: ThemeConstants.calendarHover.requestedBorder,
    workshift: ThemeConstants.calendarHover.workshift,
    workshiftBorder: ThemeConstants.calendarHover.workshiftBorder,
    posted: ThemeConstants.calendarHover.posted,
    postedBorder: ThemeConstants.calendarHover.postedBorder,
    availabilityBorder: ThemeConstants.calendarHover.availabilityBorder,
    availability: ThemeConstants.calendarHover.availability,
    tempAvailability: ThemeConstants.common.grey150,
    tempAvailabilityBorder: ThemeConstants.common.grey350,
    bookedBorder: ThemeConstants.calendarHover.bookedBorder,
    booked: ThemeConstants.calendarHover.booked,
  },

  notification: {
    notVisited: ThemeConstants.notification.notVisited,
    confirmBg: ThemeConstants.notification.confirmBg,
    indicator: ThemeConstants.notification.indicator,
  },

  payment: {
    orange: ThemeConstants.payment.orange,
    elegantGreen: ThemeConstants.payment.elegantGreen,
    recommendedColor: ThemeConstants.payment.recommendedColor,
  },

  chartColors: {
    secondaryGreen: ThemeConstants.chartColors.secondaryGreen,
    green100: ThemeConstants.chartColors.green100,
    green170: ThemeConstants.chartColors.green170,
    green200: ThemeConstants.chartColors.green200,
    green250: ThemeConstants.chartColors.green250,
    green251: ThemeConstants.chartColors.green251,
    green400: ThemeConstants.chartColors.green400,
    green800: ThemeConstants.chartColors.green800,
    green900: ThemeConstants.chartColors.green900,
    green950: ThemeConstants.chartColors.green950,
    blue50: ThemeConstants.chartColors.blue50,
    blue100: ThemeConstants.chartColors.blue100,
    blue237: ThemeConstants.chartColors.blue237,
    blue300: ThemeConstants.chartColors.blue300,
    blue800: ThemeConstants.chartColors.blue800,
    blue900: ThemeConstants.chartColors.blue900,
    pink650: ThemeConstants.chartColors.pink650,
    pink600: ThemeConstants.chartColors.pink600,
    pink800: ThemeConstants.chartColors.pink800,
    pink900: ThemeConstants.chartColors.pink900,
    pink950: ThemeConstants.chartColors.pink950,
    pink980: ThemeConstants.chartColors.pink980,
    purple300: ThemeConstants.chartColors.purple300,
    purple200: ThemeConstants.chartColors.purple200,
    orange500: ThemeConstants.chartColors.orange500,
    orange900: ThemeConstants.chartColors.orange900,
    orange950: ThemeConstants.chartColors.orange950,
    grey200: ThemeConstants.chartColors.grey200,
    greyBlend: ThemeConstants.chartColors.greyBlend,
    cyan: ThemeConstants.chartColors.cyan,
    whiteSmoke: ThemeConstants.chartColors.whiteSmoke,
    averagePharmacyRate: ThemeConstants.chartColors.averagePharmacyRate,
    averagePharmacistRate: ThemeConstants.chartColors.averagePharmacistRate,
    averageHourlyRate: ThemeConstants.chartColors.averageHourlyRate,
  },
  transactions: {
    unlimited: ThemeConstants.transactions.unlimited,

    refund: ThemeConstants.transactions.refund,
    basic: ThemeConstants.transactions.basic,
  },
};
